import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

// function formatCartPage() {
//     const priceElements = document.querySelectorAll('.cart-items__price text-component');
//     console.log('okinawa');

//     let total = 0;
//     let currencySymbol = '';
//     let currencyCode = '';
//     let usesCommaDecimal = false;

//     priceElements.forEach(element => {
//       const text = element.textContent.trim();
      
//       // Detect if this currency uses comma as decimal separator
//       // Check if there's a comma followed by exactly 2 digits at the end
//       if (text.match(/,\d{2}(?:\s|[A-Z]{3})?$/)) {
//         usesCommaDecimal = true;
//       }
      
//       // Extract numeric value based on decimal separator
//       let numericValue;
//       if (usesCommaDecimal) {
//         // European format: comma = decimal, period/space = thousands separator
//         numericValue = parseFloat(
//           text.replace(/[^\d,]/g, '') // Keep only digits and comma
//               .replace(',', '.') // Convert comma to period for parsing
//         );
//       } else {
//         // US/UK format: period = decimal, comma = thousands separator
//         numericValue = parseFloat(text.replace(/[^\d.]/g, '')); // Keep only digits and period
//       }
      
//       if (!isNaN(numericValue)) {
//         total += numericValue;
//       }
      
//       // Extract currency symbol (including compound symbols like NZ$)
//       if (!currencySymbol) {
//         const symbolMatch = text.match(/^[A-Z]{2}\$|^[^\d\s,\.]+/);
//         if (symbolMatch) {
//           currencySymbol = symbolMatch[0];
//         }
//       }
      
//       // Extract currency code
//       if (!currencyCode) {
//         const codeMatch = text.match(/[A-Z]{3}$/);
//         if (codeMatch) {
//           currencyCode = ' ' + codeMatch[0];
//         }
//       }
//     });

//     // Format the total using the same decimal separator as the input
//     let formattedTotal;
//     if (usesCommaDecimal) {
//       formattedTotal = `${currencySymbol}${total.toFixed(2).replace('.', ',')}${currencyCode}`;
//     } else {
//       formattedTotal = `${currencySymbol}${total.toFixed(2)}${currencyCode}`;
//     }
    
//     const totalPrice = document.querySelector('.cart__total-container .cart__total-value');
//     if (totalPrice) {
//       totalPrice.textContent = formattedTotal;
//     }
// }

// const originalFetch = window.fetch;
// window.fetch = function(...args) {
//   const url = args[0];
  
//   if (url.includes('/cart/change') || url.includes('/cart/update')) {
//     return originalFetch.apply(this, args).then(response => {
//       response.clone().json().then(data => {
//         setTimeout(()=>{
//           formatCartPage();
//         }, 1000);
//       });
//       return response;
//     });
//   }
  
//   return originalFetch.apply(this, args);
// };

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();
    
    // setTimeout(()=>{
    //   formatCartPage();
    // }, 1000);

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
